import { useCallback } from 'react';
import { usePreviewResultsIterator } from '@mentimeter/slides-preview-results';
import type {
  InteractiveContent,
  Range,
  ScaleResult,
} from '@core-api/presentation/types/response';
import {
  getScalesPreviewResultsIteration,
  type ScalesPreviewResults,
} from './getScalesPreviewResultsIteration';

interface UseScalesPreviewResultsProps {
  isEnabled: boolean;
  range: Range | null;
  choices: InteractiveContent['choices'];
}

/**
 * Hook for generating preview results for scales.
 * @param choices - Must be memoized to avoid unnecessary re-renders
 * @param range - Must be memoized to avoid unnecessary re-renders
 */
export const useScalesPreviewResults = ({
  isEnabled,
  choices,
  range,
}: UseScalesPreviewResultsProps): {
  results: ScaleResult[];
} => {
  const getNextResults = useCallback(
    (iteration: number, previous: ScalesPreviewResults | undefined) => {
      return getScalesPreviewResultsIteration({
        iteration,
        previous,
        choices,
        range,
      });
    },
    [choices, range],
  );

  return (
    usePreviewResultsIterator(isEnabled, getNextResults) ?? {
      results: [],
    }
  );
};
